import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export enum sortingOrder {
	ASCENDING = 'ascending',
	DESCENDING = 'descending'
}

export const HeaderItem = ({
	name,
	slugName,
	isCenter = false,
	selectedHeader,
	setSelectedHeader,
	sortOrder,
	setSortOrder
}: {
	name: string;
	slugName: string;
	isCenter: boolean;
	selectedHeader: string;
	setSelectedHeader: (slugName: string) => void;
	sortOrder: sortingOrder;
	setSortOrder: (order: sortingOrder) => void;
}) => {
	const isSelected = selectedHeader === slugName;
	return (
		<th className="p-2 whitespace-nowrap">
			<div className={`flex flex-row  ${isCenter && 'justify-center ml-4'}`}>
				<h3
					className={`cursor-pointer ${
						isSelected ? 'font-bold' : 'font-semibold'
					}`}
					onClick={() => {
						if (!isSelected) {
							setSelectedHeader(slugName);
							setSortOrder(sortingOrder.DESCENDING);
						}
					}}
				>
					{name}
				</h3>
				{isSelected ? (
					<ChevronIcon sortOrder={sortOrder} setSortOrder={setSortOrder} />
				) : (
					<div className="my-auto ml-2.5 w-3" />
				)}
			</div>
		</th>
	);
};

const ChevronIcon = ({
	sortOrder,
	setSortOrder
}: {
	sortOrder: string;
	setSortOrder: (order: sortingOrder) => void;
}) => {
	const [isAscending, setIsAscending] = useState(
		sortOrder === sortingOrder.ASCENDING
	);

	const chevClass = 'text-gray-600 my-auto ml-2 cursor-pointer';
	return isAscending ? (
		<FaChevronUp
			size="10"
			className={chevClass}
			onClick={() => {
				setSortOrder(sortingOrder.DESCENDING);
				setIsAscending(false);
			}}
		/>
	) : (
		<FaChevronDown
			size="10"
			className={chevClass}
			onClick={() => {
				setSortOrder(sortingOrder.ASCENDING);
				setIsAscending(true);
			}}
		/>
	);
};
